'use client';

import 'BomdisoftComponents/navigation/top-bar/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import type { TopBarSecondaryLink } from 'BomdisoftComponents/navigation/top-bar/render';
import type { CSSProperties, ReactNode } from 'react';

export type { TopBarLink, TopBarSecondaryLink } from 'BomdisoftComponents/navigation/top-bar/render';

export type TopBarProps = {
  brand: ReactNode;
  authSlot?: ReactNode;
  ctaLabel?: string;
  ctaHref?: string;
  ctaClassName?: string;
  barClassName?: string;
  maxWidth?: number;
  secondaryLink?: TopBarSecondaryLink;
  signInHref?: string;
  signInLabel?: string;
  testId?: string;
};

export const TopBar = ({ authSlot, barClassName, brand, ctaClassName, ctaHref, ctaLabel, maxWidth = 1200, secondaryLink, signInHref, signInLabel, testId = 'top-bar' }: TopBarProps) => {
  const hasSignIn = Boolean(signInLabel && signInHref);

  return (
    <nav className={joinClasses('bomdisoft-top-bar', barClassName)} data-testid={testId}>
      <div className='bomdisoft-top-bar-content' style={{ '--topbar-max-width': `${maxWidth}px` } as CSSProperties}>
        {brand}

        <div className='bomdisoft-top-bar-right-group'>
          {secondaryLink && (
            <a className='bomdisoft-top-bar-secondary-link' data-testid={secondaryLink.testId ?? `${testId}-secondary-link`} href={secondaryLink.href}>
              {secondaryLink.label}
            </a>
          )}
          {hasSignIn && (
            <a className='bomdisoft-top-bar-sign-in' data-testid={`${testId}-sign-in`} href={signInHref}>
              {signInLabel}
            </a>
          )}
          {ctaHref && (
            <a className={joinClasses('bomdisoft-top-bar-cta', ctaClassName)} data-testid={`${testId}-cta`} href={ctaHref}>
              {ctaLabel}
            </a>
          )}
          {authSlot}
        </div>
      </div>
    </nav>
  );
};
